<template>
  <div :class="['jp-alert', 'text8', variant && `alert--${variant}`]">
    <FontIcon :name="fontIconName(variant)" :class="[variant, 'text5']" />
    <span class="alert-content">
      <slot />
    </span>
  </div>
</template>

<script>
import FontIcon from "../FontIcon/FontIcon";

export default {
  components: {
    FontIcon,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: Number,
      default: 10,
    },
    variant: {
      type: String,
      default: "info",
      validator(type) {
        return ["info", "error", "success", "warning"].includes(type);
      },
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          setTimeout(() => {
            this.$emit("input", false);
          }, this.timeout * 1000);
        }
      },
    },
  },

  methods: {
    fontIconName(variant) {
      let iconName;

      switch (variant) {
        case "error":
          iconName = "ui_close";
          break;
        case "success":
          iconName = "ui_check";
          break;
        case "warning":
          iconName = "ui_status_caution";
          break;
        default:
          iconName = "";
      }
      return iconName;
    },
  },
};
</script>

<style lang="scss">
.jp-alert {
  padding: 16px;
  margin-bottom: rem(16px);

  &.alert--error {
    @include setColor(--color-status-error, background-color);
    @include setColor(--color-text-negative);
  }

  &.alert--success {
    background-color: rgba(map-get($colors, --color-status-success), 0.2);

    a {
      @include setColor(--color-text, color, true);
    }
  }

  &.alert--warning {
    @include setColor(--color-status-warning, background-color);
    @include setColor(--color-text-negative);
  }

  .font-icon.text5 {
    display: inline-block;
    margin: 0 rem(18px) 0 0;
    vertical-align: middle;
    line-height: initial;

    &.success {
      @include setColor(--color-status-success, background-color);
      @include setColor(--color-text-negative);
      border-radius: rem(28px);
      padding: rem(6px);
      font-size: rem(14px);
    }

    &.warning {
      font-size: rem(20px);
    }

    &.error {
      font-size: rem(14px);
    }
  }

  .alert-content {
    display: inline-block;
    width: calc(100% - 50px);
    vertical-align: middle;
  }

  border-radius: 2px;
  @include setColor(--color-text);
}
</style>
